import { render } from "./RequestDossierModal.vue?vue&type=template&id=14cf2590&scoped=true"
import script from "./RequestDossierModal.vue?vue&type=script&lang=js"
export * from "./RequestDossierModal.vue?vue&type=script&lang=js"

import "./RequestDossierModal.vue?vue&type=style&index=0&id=14cf2590&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cf2590"]])

export default __exports__